import TranslationsConfigType from './translationType';

const nnTranslations: TranslationsConfigType = {
    annenEiendom: {
        labelGateadresse: 'Gateadresse',
        labelPostnummer: 'Postnummer',
    },
    barn: {
        title: 'Barn i hushaldet',
        subTitle:
            'Vi har henta informasjon om dine barn under 18 år frå Folkeregistreret. ' +
            'Om du har barn under 18 år som ikkje blir vist i lista, så skal desse leggjast til nedanfor.',
        subTitleGutt: 'Gutt',
        subTitleJente: 'Jente',
        labelFoedselsdato: 'Barnets fødselsdato',
        labelBetalerBarnebidrag: 'Betaler barnebidrag',
        labelMottarBarnebidrag: 'Får barnebidrag',
        labelSfoUtgifter: 'SFO',
        labelKjoenn: 'Kva kjønn er barnet?',
        radioTitleForeldreansvar: 'I kva grad har du foreldreansvar?',
        radioFullOmsorg: 'Full omsorg',
        radioDeltOmsorg: 'Delt omsorg',
        radioIngenOmsorg: 'Inga omsorg',
        radioTitleSfo: 'Er barnet deltid eller heiltid på SFO?',
        radioHeltid: 'Heiltid',
        radioDeltid: 'Deltid',
        togglesHarBarn: 'Har du omsorg for barn under 18 år?',
        togglesBetalerBarnebidrag: 'Betaler du barnebidrag?',
        togglesMottarBarnebidrag: 'Får du barnebidrag?',
        togglesSfoUtgifter: 'Har du utgifter til SFO?',
        togglesGutt: 'Gut',
        togglesJente: 'Jente',
        infoDsfError: 'Opplysningane kunne ikkje hentast frå Folkeregisteret. Ver vennleg og fyll ut skjemaet.',
    },
    biler: {
        title: 'Dine bilar',
        titleHusholdning: 'Bilar i hushaldet',
        subTitle:
            'Vi har henta informasjon om bilar du eig eller leasar frå Køyretøyregisteret. ' +
            'Dersom du eig eller leasar andre bilar, kan du leggje dei til manuelt.',
        subTitleNb: 'NB: Gjeld berre bilar der du er eigar (ikkje medeigar).',
        subTitleHusholdning:
            'Her registrerer du informasjon om alle bilar i hushaldet, også for eventuell medlåntakar.',
        labelLeaset: 'Månadleg utgift til leasing',
        radioBensin: 'Bensin/bensin-hybrid',
        radioDiesel: 'Diesel/diesel-hybrid',
        radioElektrisitet: 'Elektrisitet',
        radioTitleDrivstoff: 'Kva drivstoff bruker bilen?',
        toggelsErLeaset: 'Er bilen leasa?',
        toggelsHarBil: 'Har du bil?',
        toggelsHarBilHusholdning: 'Har du/dokker bil i hushaldet?',
        eier: 'Eigar',
        leasingtaker: 'Leasingeigar',
        registreringsnummer: 'Registreringsnummer',
        drivstoff: 'Drivstoff',
        drivstoffTyper: {
            bensin: 'Bensin',
            diesel: 'Diesel',
            elektrisk: 'Elektrisk',
            hybridBensin: 'Hybrid (Bensin)',
            hybridDiesel: 'Hybrid (Diesel)',
            parafin: 'Parafin',
            gass: 'Gass',
            hydrogen: 'Hydrogen',
            annet: 'Anna',
            biodiesel: 'Biodiesel',
            biobensin: 'Biobensin',
            lpg: 'LPG',
            cng: 'CNG',
            metanol: 'Metanol',
            etanol: 'Etanol',
            komprimertLuft: 'Komprimert luft',
            lng: 'LNG',
            cngLng: 'CNG/LNG',
        },
    },
    boligPant: {
        togglesBoligPant: 'Har du gjeld med pant i denne bustaden?',
        togglesBoligPantEksisterendeLaan: 'Har du anna gjeld med pant i denne bustaden?',
        labelBoligPant: 'Restsaldo på gjeld',
    },
    boligSalg: {
        title: 'Selje bustad',
        infoLaanIDag: 'Lån i dag',
        infoAntattBoligverdi: 'Anteken bustadverdi',
        labelHvilkenBoligSkalSelges: 'Kva bustad skal du selje?',
        togglesSelgeBolig: 'Har du ein bustad som skal seljast?',
        togglesHarPantIBolig: 'Har du gjeld med pant i denne bustaden?',
    },
    boligVerdi: {
        title: 'Bustadverdi',
        titleLaanbeloep: 'Bustadverdi og lånebeløp',
        infoAntattBoligverdi: 'Anteken bustadverdi',
        infoAndelFellesgjeld: 'Andel fellesgjeld',
        infoNyEtakstverdi: 'Ny bustadverdi frå E-takst',
        infoNyEtakstFellesgjeld: 'Ny fellesgjeld frå E-takst',
        infoLaanIDag: 'Lån i dag',
        infoIkkeFunnet: 'Ikkje funne',
        labelRestgjeld: 'Kva er restgjeld på lånet som skal flyttast?',
        labelLaanebeloep: 'Kor mykje ønskjer du å låna?',
        labelOekelaan: 'Kor mykje ønskjer du å auke lånet med?',
        labelFraBank: 'I kva bank er lånet i dag?',
        togglesOekeLaan: 'Ønskjer du å auke det nye lånet?',
    },
    button: {
        avbryt: 'Avbryt',
        ja: 'Ja',
        fjern: 'Fjern',
        forrige: 'Forrige',
        fortsett: 'Hald fram',
        fortsettSoeknad: 'Fortsett søknad',
        gaaTilForsiden: 'Gå til framsida',
        gaaTilbakeTilSoeknad: 'Gå tilbake til søknaden',
        iconButtonInformasjon: 'Informasjon',
        iconButtonMinus: 'Minus',
        iconButtonPlus: 'Plus',
        iconButtonSlett: 'Slett',
        lagre: 'Lagre',
        lagreOgFortsett: 'Lagre og fortsett seinare',
        leggTilBil: 'Legg til bil',
        leggTilBarn: 'Legg til fleire barn',
        leggTilArbeidsinntekt: 'Legg til ny arbeidsinntekt',
        leggTilGjeld: 'Legg til gjeld',
        loggInnPaaNytt: 'Logg inn på nytt',
        loggUt: 'Logg ut',
        lukk: 'Lukk',
        nei: 'Nei',
        neste: 'Neste',
        provIgjen: 'Prøv om att',
        send: 'Send',
        sendSoeknad: 'Send søknad',
        slettSoeknad: 'Slett søknaden',
        bekreftSlettSoeknad: 'Bekreft sletting',
        startNySoeknad: 'Start ny søknad',
        startSoeknadPaaNytt: 'Start søknad på nytt',
        avsluttSoeknad: 'Avslutt søknad',
    },
    deleteSoeknad: {
        title: 'Ønskjer du å lagra det du har skrive til no?',
        subTitle: 'Viss du vil fullføra søknaden seinare, så lagrar vi han i 7 dagar..',
        titleBekreft: 'Er du sikker på at du vil sletta søknaden?',
        subTitleBekreft: 'Kvifor ønskjer du å sletta søknaden din? (Valfritt)',
        titleSoeknadSlettet: 'Søknaden er sletta',
        soeknadErSlettet:
            'Om du har gitt tilbakemelding blir dette lagra anonymt, og vil brukast til å forbetra tenestene våre.',
    },
    egenkapital: {
        title: 'Eigenkapital',
        subTitle: 'Me treng informasjon om eigenkapitalen din for å kunna berekna kor mykje du/de kan låna.',
        labelEgenkapital: 'Eigenkapital',
        subLabelEgenkapital: 'Oppgi berre din del av eigenkapitalen om du har ein medlåntakar på søknaden.',
        togglesEgenkapital: 'Har du sparepengar som skal nyttast som eigenkapital i bustadkjøpet?',
        checkboxEgenkapital: {
            title: 'Kvar kjem eigenkapitalen din frå?',
            loenn: 'Løn',
            pensjon: 'Pensjon',
            sparing: 'Sparing',
            trygd: 'Trygd',
            arvEllerGave: 'Arv eller gåve',
            egenkapitalSalgEiendom: 'Eigenkapital fra eiendomssal',
            annen: 'Anna',
        },
        modalInfoBox: {
            titleHarSparepenger: 'Har du sparepenger som skal nyttast som eigenkapital?',
            harSparepenger:
                'Fyll ut pengar du har på konto i bank eller i fond som du kan bruka til bustadkjøp. ' +
                'Forbrukslån blir ikkje godteke som eigenkapital.',
            titleHvorKommerEgenkapitalFra: 'Kvar kjem eigenkapitalen din frå?',
            hvorKommerEgenkapitalFra:
                'Kvitvaskingslova pålegg bankane å ha kunnskap om kundane sine. ' +
                'Eit av krava er at me må vita kvar pengane til kundane kjem frå. ' +
                'Du kan kryssa av på eitt eller fleire av vala.',
        },
    },
    eiendomBruk: {
        label: 'Kva skal bustaden brukas til?',
        selectValueBo: 'Bustaden eg skal bo i',
        selectValueUtleie: 'Bustaden eg skal leige ut',
        selectValueFritid: 'Fritidsbustad / hytte',
    },
    eiendomList: {
        title: 'Kva for ein bustad gjelder søknaden?',
        annenEiendom: 'Oppgje anna adresse',
    },
    eiendomVariant: {
        labelTypeBolig: 'Type bustad',
        labelTypeBoligSerEtter: 'Kva for ein type bustad ser du etter?',
        selectValueEnebolig: 'Einebustad',
        selectValueLeilighet: 'Leilegheit',
        selectValueRekkehus: 'Rekkehus',
        selectValueTomannsbolig: 'Tomannsbustad',
        selectValueSelveier: 'Sjølveigar',
        selectValueAndelIBorettslag: 'Andel i burettslag',
        selectValueAksjeleilighet: 'Aksjeleilgheit',
    },
    etakst: {
        togglesLabel: 'Har du ein oppdatert E-takst?',
        togglesSublabel: 'E-takst må være nyere enn tre måneder',
        inputLabel: 'E-takstens referanse',
        inputSubLabel: 'Den består av 5 teikn, og du finn han i E-takst fila frå megler.',
        invalidETakst: 'Referanse er ikkje gyldig',
        validETakst: 'Gyldig referanse for E-takst',
        infoETakst: 'Ny bustadverdi fra E-takst',
        infoModalTitle: 'Kva er ein E-takst? ',
        infoModalParagraf1:
            'Ein elektronisk takst (E-takst) er ein bransjestandard for verdivurdering. Den er basert på statistiske data om tilsvarande bustader i området og meklars erfaring med sal i dagens bustadmarknad. E-taksten inneheld verdien på bustaden og kva han kan bli selt for i dagens marknad.',
        infoModalParagraf2:
            'For å kunna gi deg ein realistisk bustadverdi, vil ein eigedomsmeklar komma på synfaring for å vurdera bustaden. Sjølve dokumentasjonen og E-taksten blir lagra i eit felles system, som både du og banken får tilgang til.',
    },
    errorDsfModal: {
        title: 'Feil ved henting av kundeinformasjon',
        description: 'Det har oppstått feil ved henting av kundeinformasjon. Prøv igjen seinare.',
    },
    finansieringsbevis: {
        title: 'Bustad',
        subTitle:
            'Denne søknaden er for deg som ønskjer å søkja bustadlån, men ikkje har funne ein konkret bustad enno.',
        formTitle: 'Hei,',
        formSubTitle: 'Me trenger litt informasjon om bustaden du skal kjøpe.',
    },
    flytteBoliglaan: {
        title: 'Vel bustad',
        subTitle: 'Denne søknaden er for deg som har eit eksisterande bustadlån du ønskjer å flytta til oss.',
        formTitle: 'Hei,',
        formSubTitle: 'Me treng litt informasjon om bustaden du har belånt i dag.',
    },
    gjeld: {
        title: 'Gjeld',
        subTitle:
            'Me hentar inn gjelda di frå ulike register. Dersom du har annan gjeld så er det viktig at du legg det til.',
        infoTitle: 'Dette hentar me inn:',
        infoGjeldIBank: 'Gjeld i banken frå kjernesystemet til banken',
        infoUsikretGjeld: 'Usikra gjeld som til dømes kredittkort og forbrukslån frå Gjeldsregisteret',
        infoStudielaan: 'Studielån frå førre skatteoppgjer via Altinn',
        infoAndelFellesgjeld: 'Andel fellesgjeld frå Eiendomsverdi dersom du eig ein burettsandel',
        infoBillaan: 'Lån med pant i bil fra Dun & Bradstreet',
        infoBilensKjennetegn: 'Bilens kjenneteikn',
        infoBilPant: 'Pant i bilen',
        infoSamletGjeld: 'Samla gjeld',
        infoSamletGjeldErstattes: 'Gjeld som skal nedbetalast med nytt lån',
        infoGjeldSum: 'Samla gjeld',
        infoGjeldInfrisSum: 'Gjeld som skal nedbetalas med nytt lån',
        infoGjeldsregister:
            'Logg inn hos Gjeldsregisteret for detaljar om gjeld dersom du er usikker på kva postane er',
        infoGjeldsregisterError:
            'Opplysningane kunne ikkje hentast frå Gjeldsregisteret. Ver vennleg og fyll ut skjemaet.',
        infoDagensSaldo: 'Dagens saldo',
        infoDagensKredittramme: 'Dagens kredittramme',
        infoKredittramme: 'Kredittramme',
        infoRestgjeld: 'Restgjeld',
        infoTypeLaan: 'Type lån',
        infoInnfris: 'Blir erstatta av det nye lånet.',
        labelBankensNavn: 'Bankens namn',
        labelRestGjeld: 'Kva er restgjeld på kreditten?',
        labelMaanedligeFellesutgifter: 'Kva er dine månadlege fellesutgifter til burettslaget?',
        labelBillaanSaldo: 'Kva er dagens saldo på billånet?',
        labelRestGjeldStudielaan: 'Restgjeld på studielånet',
        labelTypeLaan: 'Type lån / kreditt',
        subTitleBoliglaan: 'Bustadlån',
        subTitleStatensLaanekasse: 'Statens Lånekasse',
        subTitleKredittkort: 'Kredittkort',
        subTitleForbrukslaan: 'Forbrukslån',
        subTitleFaktureringskort: 'Faktureringskort',
        subTitleBillaan: 'Billån',
        selectValueDefault: 'Vel et alternativ',
        selectValueBillaan: 'Billån',
        selectValueStudielaan: 'Studielån',
        selectValueBoliglaan: 'Boliglån',
        selectValueAnnet: 'Anna',
        toggelsNedbetaleGjeld: 'Skal denne gjelden nedbetalast med nytt lån?',
        toggelsHarGjeld: 'Har du lån eller kreditter?',
    },
    inntekt: {
        title: 'Inntekt',
        subTitle:
            'Me har henta lønnsslippar for siste halvår og siste skattemelding frå Skatteetaten. Dersom du har anna arbeidsinntekt legg du dei til her',
        labelArbeidsgiver: 'Arbeidsgivar',
        labelInntekt: 'Årleg inntekt før skatt',
        radioTitleArbeidssituasjon: 'Kva er arbeidssituasjonen din?',
        radioFastAnsatt: 'Fast tilsett',
        radioMidlertidigAnsatt: 'Midlertidig tilsett',
        radioMottakerAvPensjon: 'Mottakar av pensjon/trygd',
        radioSelvstendigNaeringsdrivende: 'Sjølvstendig næringsdrivande',
        toggelsHarInntekt: 'Har du skattepliktig inntekt?',
        toggelsErNaavaerendeInntekt: 'Er dette den noverande inntekta di?',
        infoSblError:
            'Det har skjedd ein feil ved henting av inntektsopplysningar frå Skatteetaten. Prøv igjen seinare eller legg til inntekt og hald fram søknaden.',
    },
    kjoepBolig: {
        title: 'Velg bustad',
        subTitle:
            'Denne søknaden er for deg som har funne ein ny bustad du ønskjer å kjøpa, eller som du allereie har kjøpt.',
        formTitle: 'Hei,',
        formSubTitle: 'Me treng litt informasjon om bustaden du har kjøpt eller skal kjøpa.',
        labelGateadresse: 'Gateadresse',
        labelPostnummer: 'Postnummer',
        labelKjoepesum: 'Kjøpesum',
        subLabelKjoepesum: 'Utan kostnader',
        labelAndelFellesgjeld: 'Andel fellesgjeld',
        labelOvertakelse: 'Forventa dato for overtakning',
        labelAndel: 'Vel riktig andel',
        labelMatrikkel: 'Vel riktig seksjon',
    },
    kontaktinfoHovedlaantaker: {
        title: 'Kontaktinformasjonen din',
        subTitle: 'For å kunna kontakta deg i etterkant av søknaden, treng me kontaktinformasjonen din.',
        labelMobil: 'Mobil',
        labelEpost: 'E-post',
    },
    kontaktinfoMedlaantaker: {
        togglesHarMedlaantaker: 'Har du medlåntakar?',
        title: 'Medlåntakars kontaktinformasjon',
        labelFornavn: 'Fornamn og evt. mellomnamn',
        labelEtternavn: 'Etternamn',
        labelFoedselsnummer: 'Personnummer',
        labelMobil: 'Mobil',
        labelEpost: 'E-post',
        infoEksisterendeMedlaantaker:
            'Me sender SMS og e-post til medlåntakar med vidare instruks etter du har fullført og sendt inn din del av søknaden.',
        infoNyMedlaantaker:
            'Det krevst at du fyller ut fullt namn og fødselsnummer til medlåntakaren din, slik at me kan vera sikre på at det er rett person. ' +
            'Me sender SMS og e-post til medlåntakar med vidare instruks etter at du har fullført og sendt inn din del av søknaden.',
        navnEksisterendeMedlaantaker: 'Namn',
    },
    kvittering: {
        title: 'Takk for din søknad!',
        paragrafLaantaker:
            'Me har fått søknaden og sender deg kvittering på SMS og e-post. Du høyrer frå oss så snart saka blir behandla.',
        paragrafMedlaantaker1:
            'Me har sendt ut SMS/e-post til {namn} som må fullføra sin del av søknaden før han blir sendt ut. Når dette er gjort vil de høyre frå oss så snart saka blir behandla.',
        paragrafMedlaantaker2: 'Hugs å logga av denne brukaren før medlåntakar startar sin del av søknaden.',
        paragrafTilbakemelding:
            'Me er ikkje i mål, men jobbar heile tida for å gjera søknadsprosessen enklare og raskare',
        titleTilbakemelding: 'Hjelp oss å gjera søknadsprosessen betre!',
        togglesTilbakemelding: 'Likte du søknadsskjemaet for bustadlån?',
        labelTilbakemelding: 'Har du innspel, ønske eller forbetringsforslag?',
        subLabelTilbakemelding:
            'Meldinga di er anonym og me kan derfor ikkje svara deg. Dersom du treng hjelp må du kontakta kundeservice direkte.',
        infoTilbakemeldingTakk: 'Takk for tilbakemeldinga!',
        infoTilbakemeldingViktig: 'Di meining er viktig for oss.',
        verdivurderingFeil:
            'Førespurnad om verdivurdering til Aktiv eigedomsmekling feila. Du kan sende ny førespurnad på aktiv.no',
    },
    laanebeloep: {
        title: 'Lånebeløp',
        infoDittBoliglaanIDag: 'Bustadlånet ditt i dag',
        infoLaanIDag: 'Lån i dag',
        infoKredittrammeIDag: 'Kredittramme i dag',
        infoMaksimaltLaanebeleop: 'Maksimal auking',
        labelLaaneoekning: 'Kor mye ønskjer du å auke lånet med?',
        labelOensketLaanebeloep: 'Kor mykje ønskjer du å låne?',
        labelNedbetalingstid: 'Kor lang nedbetalingstid (år) ønskjer du?',
        infoNyttBoliglaan: 'Nytt bustadlån',
        infoNyttBoliglaanOverstiger:
            'Føreset at du har inntekt nok til å betena lånet og at lånet ikkje overstig fem gonger inntekta di.',
        infoNyttLaanebeloep: 'Nytt lånebeløp',
        infoNyNebetalingstid: 'Ny nedbetalingstid',
        infoNyttMaanteligBeloep: 'Nytt månadleg beløp',
        infoBelaaningsgrad: 'Belåningsgrad',
        infoNyKredittramme: 'Ny kredittramme',
        infoLinkOmBergning: 'Om berekning',
        popupInfoLaanIDag:
            'Om du har bustadlån på den valde bustaden hos oss, så nyttar me dagens lånesaldo i berekninga.',
        popupInfoMaksimaltOekning:
            'Du kan maksimalt låna fem gonger din og ein evt. medlåntakars inntekt. Berekninga tek ikkje omsyn til eventuell motteken eller teken realkausjon.',
        popupInfoSubTitleLaanIDag: 'Lån i dag',
        popupInfoSubTitleMaksimaltOekning: 'Maksimal auke av bustadlån',
        popupInfoTitle: 'Om berekning',
        subLabelOensketLaanebeloep:
            'Estimert utifrå dagens lånegrad og bustadverdi, kan du auka bustadlånet med inntil {maksoekning} kr.',
        warningLaaneoekning60:
            'Ramma på eit fleksilån kan maksimalt utgjera 60% av verdien på bustaden.' +
            'Med denne låneauken kan det vera at fleksilånet må gjerast om til ein nedbetalingslån.',
        warningLaaneoekning90:
            'Ønskt låneauke ser ut til å overstiga kravet om maksimal 90% låneopptak på bustad. ' +
            'Me gjer merksam på at det kan bli stilt krav om trygg tilleggstryggleik eller ein ny ' +
            'verdivurdering av bustaden dersom du ønskjer å halda fram søknaden med dette lånebeløpet.',
        formaal: 'Hva er formålet med opplåningen?',
        formaalOppussing: 'Oppussing av bolig',
        formaalByggeBolig: 'Bygge på bolig',
        formaalKjoepeBil: 'Kjøp av bil',
        formaalInnfriGjeld: 'Innfri annen gjeld',
        formaalAnnet: 'Annet',
        formaalAnnetTitle: 'Beskriv formålet med opplåningen',
    },
    laaneformaal: {
        title: 'Søknad om bustadlån',
        subTitle: 'Det krevst innlogging med BankID for å fullføra lånesøknaden.',
        labelLaaneformaal: 'Kva skal bustadlånet nyttast til?',
        labelKjoepFinansieringsbevis: 'Har du funne ein bustad du ønskjer å kjøpa?',
        selectValueKjoepBolig: 'Kjøpe bustad',
        selectValueOekelaan: 'Øke bustadlånet ditt',
        selectValueFlytteLaan: 'Flytte lånet frå ein annan bank',
        selectValueByggeRenovereBolig: 'Byggja eller totalrenovera bustad',
        selectValueKonkretBolig: 'Ja, eg søkjer om lån til kjøp av ein konkret bustad',
        selectValueFinansieringsbevis: 'Nei, eg lurer på kor mykje eg kan låna til å kjøpa bustad (finansieringsbevis)',
        infoKjoepBolig: 'For deg som søkjer om finansieringsbevis eller lån til å kjøpa bustad.',
        infoOekelaan:
            'For deg som har bustadlån i dag og ønskjer å auka dette. Dette valet blir også brukt viss du ønskjer å søkja om nytt lån på gjeldsfri bustad.',
        infoFlytteLaan:
            'For deg som har bustadlån i ein annan bank og ønskjer eit nytt uforpliktande tilbod. Her kan du søkja om auke av lånet som blir flytta.',
        infoByggeRenovereBolig: 'For deg som ønskjer å byggja eller totalrenovera bustad.',
    },
    leieinntekt: {
        title: 'Leigeinntekter',
        subTitle:
            'Her registrerer du informasjon om alle leigeinntekter i hushaldet, også for ein eventuell medlåntakar.',
        subTitleUtleiekontrakt: 'Last opp leigekontrakt (Valfritt)',
        labelSkattefrieLeieinntekt: 'Månadleg skattefri leigeinntekt',
        labelSkattepliktigLeieinntekt: 'Månadleg skattepliktig leieinntekt',
        toggelsHarSkattefrieLeieinntekt: 'Har du, eller vil du få, skattefrie leigeinntekter?',
        toggelsHarSkattepliktigLeieinntekt: 'Har du, eller vil du få, skattepliktig leigeinntekter?',
        infoUteleikontrakt1:
            'Vi må sjå signert leigekontrakt for kvart leigeforhold for å kunne ta med desse inntektene i berekninga.',
        infoUteleikontrakt2:
            'Om du ikkje har dette tilgjengeleg akkurat no, så sender vi deg ei oppgåve om dette etter at søknaden er sendt inn.',
    },
    medlaantaker: {
        titleDeresSoeknad: 'Søknaden deira',
        infoNaavaerendeBoliglaan: 'Noverande bustadlån',
        infoOensketOekning: 'Ønskte auke',
        infoDereSoekerOm: 'De søkjer om',
        infoOver: 'over',
        titleOppfoertSomMedlaantaker: 'Du er oppført som medlåntakar',
        infoOekeBoliglaan:
            '{namn} har oppgitt deg som medlåntakar i ein søknad om å auka bustadlåna deira. Me treng ditt samtykke med BankID, og informasjon om arbeidssituasjonen din, inntekt og gjeld før søknaden kan behandlast.',
        infoFlytteBoliglaan:
            '{namn} har oppgitt deg som medlåntakar i ein søknad om å flytta bustadlåna deira. Me treng ditt samtykke med BankID, og informasjon om arbeidssituasjonen din, inntekt og gjeld før søknaden kan behandlast.',
        infoKjoepeBolig:
            '{navn} har oppgitt deg som medlåntakar i ein søknad om bustadlån. Me treng ditt samtykke med BankID, og informasjon om arbeidssituasjonen din, inntekt og gjeld før søknaden kan behandles.',
        infoFinasiertingsbevis:
            '{navn} har oppgitt deg som medlåntakar i ein søknad om finansiering til ny bustad. Me treng ditt samtykke med BankID, og informasjon om arbeidssituasjon din, inntekt og gjeld før søknaden kan behandles.',
        subTitleKontaktinfo: 'Kontaktinformasjon',
        labelDinEpost: 'Din e-post',
        labelDittMobilnr: 'Ditt mobilnummer',
    },
    oekeBoliglaan: {
        title: 'Vel bustad',
        subTitle:
            'Denne søknaden er for deg som ønskjer å låna meir på den noverande bustaden din, til f.eks vedlikehald eller oppgraderingar.',
        formTitle: 'Hei,',
        formSubTitle:
            'Me hentar dei bustadene du står som eigar av frå Eiendomsregisteret. Kjem ikkje bustaden din opp, kan du leggja han til manuelt.',
    },
    oppsummering: {
        title: 'Oppsummering',
        subTitleKontaktinfo: 'Kontaktinformasjon',
        subTitleBeskjedRaadgiver: 'Ønskjer du å leggja til ein beskjed til rådgivar?',
        infoNaavaerendeBoliglaan: 'Nåværende boliglån',
        infoFlytteBoliglaan: 'Flytte bustadlån',
        infoFinansieringsbevis: 'finaniseringsbevis.',
        infoOensketOekning: 'Ønskte auke',
        infoNyttBoliglaan: 'Nytt bustadlån',
        infoKjoepBolig: 'bustadlån med adresse',
        infoDereSoekerOm: 'De søkjer om',
        infoDuSoekerOm: 'Du søkjer om',
        infoOver: 'over',
        infoSms:
            'Me sender ein sms og e-post til {namn} med vidare instruksjonar, slik at hen kan fullføra sin del av søknaden.',
        infoSend:
            'Ved å sende inn søknaden stadfestar eg at dei oppgitte opplysningane om min økonomiske situasjon er korrekte, og at det kan gjennomførast ein kredittsjekk av meg som eg vil motta ei stadfesting på. Eg er også kjend med at eventuelle uriktige eller tilbakehaldne opplysningar eller dokumentasjon frå mi side kan resultere i at innvilga kreditt og kredittavtalen vert heva av banken.',
        labelBeskjed: 'Beskjed (valgfritt)',
        labelDinEpost: 'Din e-post',
        labelDittMobilnr: 'Ditt mobilnummer',
        labelMedlaantakerEpost: 'Medlåntakers e-post',
        labelMedlaantakerMobilnr: 'Medlåntakers mobilnummer',
    },
    paabegyntSoeknadModal: {
        title: 'Me fann ein påbyrja søknad',
        description: 'Ønskjer du å halda fram på denne søknaden?',
    },
    pageCard: {
        neste: 'Neste',
    },
    pageHeader: {
        finansieringsbevis: 'Søknad om finansieringsbevis',
        flytteBoliglaan: 'Søknad om å flytta bustadlån',
        kjoepeBolig: 'Søknad om å kjøpa bustad',
        refinansiereBoliglaan: 'Søknad om å auka bustadlånet',
        nyttBoliglaan: 'Søknad om nytt bustadlån',
    },
    pageName: {
        barn: 'Barn i hushaldet',
        biler: 'Bilar i hushaldet',
        boligsalg: 'Selja bustad',
        boligverdi: 'Bustadverdi',
        egenkapital: 'Eigenkapital',
        geolokasjon: '',
        gjeld: 'Gjeld',
        inntekt: 'Inntekt',
        kontaktinformasjon: 'Kontaktinformasjonen din',
        kvittering: '',
        laanebeloep: 'Lånebeløp',
        leieinntekt: 'Leigeinntekte',
        oppsummering: 'Oppsummering',
        samtykke: 'Samtykke',
        vedlegg: 'Vedlegg',
    },
    samtykke: {
        title: 'Samtykke',
        subTitle: 'For å vurdera lånesøknaden din treng me ditt samtykke til å henta ut informasjon om deg.',
        infoTitle: 'Me hentar informasjon frå følgjande kjelder digitalt',
        infoSkatt: 'Skatte- og inntektsopplysningar frå Skatteteaten',
        infoGjeld: 'Informasjon om gjeld frå Skatteetaten og Gjeldsregisteret',
        inforDsf: 'Informasjon om sivilstatus og barn frå Folkeregisteret',
        infoKreditt: 'Me gjennomfører også ein kredittsjekk når du sender inn søknaden',
        infoSamtykke: 'Du må logga inn og gi samtykke hos Altinn for å gå vidare med søknaden digitalt.',
        infoError:
            'Automatisk innhenting av skatt og inntektsopplysningar fungerer ikkje akkurat no. Kom tilbake seinare, eller trykk “Neste” for å halda fram søknaden utan førehandsutfylte opplysningar.',
        infoSamtykkeAkseptert:
            'Me har fått ditt samtykke og førehandsutfylt informasjonen i søknaden. Sjå over og fullfør utfyllinga før du sender inn søknaden.',
        infoAutomatiskBehandlet:
            'Ved å gå vidare samtykkjer eg til at banken opprettar ein lånesøknad og lagrar naudsynte data om meg. Søknaden kan bli behandla automatisk. Du kan lese meir om automatiske prosessar og korleis vi behandlar personopplysningane dine på',
    },
    userMessage: {
        tittleError: 'Noko gjekk feil',
        tittleTimeout: 'Du vart logga ut',
        tittleNotFound: 'Søknad ikkje funnet',
        titleSystemUnavaiable: 'Ein feil har oppstått',
        tittleSoeknadExists: 'Me fann ein påbyrja søknad',
        tittleMedlaantakerActive: 'Me fann ein aktiv søknad',
        tittleGeoOmmrade: 'Busett utanfor marknadsområdet til banken?',
        tittleSoeknadSendtInn: 'Søknad sendt inn',
        tittleUnder18: 'Under aldersgrense',
        descriptionError: 'Det har skjedd ein feil ved henting av data. Prøv igjen eller hald fram seinare.',
        descriptionTimeout:
            'Det gjekk for lang tid utan aktivitet, så du vart logga ut. Opplysningane dine blir lagra i 10 dagar, så du kan logga inn for å fullføra søknaden når det passar deg.',
        descriptionNotFound: 'Me finn ingen aktive søknader på deg.',
        descriptionSystemUnavaiable:
            'Me får ikkje henta nødvendige opplysningar frå Folkeregisteret akkurat no. Det fungerer derfor ikkje å søkja om bustadlån no. Ver vennleg og prøv igjen seinare.',
        descriptionSoeknadExists: 'Ønskjer du å halda fram på denne søknaden?',
        descriptionMedlaantakerActive:
            'Du får beskjed så snart medlåntakaren din har fullført sin del av søknaden. Søknaden går deretter vidare til ein rådgivar for behandling.',
        descriptionGeoOmmrade:
            'Banken tilbyr primært bustadlån til personar busett i marknadsområdet til banken. Det ser ut til at du er busett ein annan stad. Ring banken så hjelper me deg vidare.',
        descriptionSoeknadSendtInn: 'Søknad er sendt inn. Du må starta ny søknad viss du ønskjer å endra søknaden.',
        descriptionUnder18:
            'Du må vera over 18 år og busett i Noreg for å søkja om bustadlån digitalt. Ta kontakt med banken dersom du har spørsmål.',
    },
    validationMessage: {
        foedselsdatoUnder18aar: 'Ugyldig fødselsdato, må vera under 18år',
        patternEpost: 'Ugyldig e-post format',
        patternTlf: 'Ugylig mobilnummer, må innehalda nøyaktig 8 siffer',
        requiredChoose: 'Ver venleg og vel eit alternativ',
        requiredValue: 'Ver vennleg og fyll ut dette feltet',
        nedbetalingsTidValue: 'Nedbetalingstid må væra mellom 1 og 30 år',
        foedselsnummerToShort: 'Fødselsnummer må innehalda minst 11 siffer',
        foedselsnummerToLong: 'Fødselsnummer må ikkje innehalda meir enn 11 siffer',
        personnummerNavnDsf: 'Angitt personnummer samsvarer ikkje med angitt namn i Folkeregisteret',
        postnummerToLong: 'For langt postnummer',
        postnummerToShort: 'For kort postnummer',
        invalidPostnummer: 'Ugyldig postnummer',
        invalidDato: 'Ugyldig datoformat',
        minDato: 'Dato må vera fram i tid',
        maxDato: 'Dato er for langt frami tid',
    },
    vedlegg: {
        title: 'Vedlegg (valfritt)',
        subTitleLastOppVedlegg:
            'Dersom du har vedlegg som er relevante for lånesøknaden din, kan du laste opp desse her.',
        subTitleVedlegg: 'Vedlegg',
        infoMegabyte: 'MB',
        infoTotalt: 'Totalt',
        infoVedlegg: 'Døme: Ny tilsetjingskontrakt om du nettopp har bytt jobb',
        infoSky: 'Dra filer hit, eller',
        linkButtonSky: 'vel filer her',
        radioTitleKategori: 'Kva slags fil er dette?',
        radioAnsettelseskontrakt: 'Tilsetjingskontrakt',
        radioHusleiekontrakt: 'Husleigekontrakt',
        radioKontoutskrift: 'Kontoutskrift',
        radioAnnet: 'Anna',
        feilmeldingTittel: 'Følgjande feil skjedde under opplasting av filer:',
        feilFiltype: 'Fila {filnamn} har ein filtype som ikkje blir støtta ({filtype}).',
        feilFilForStor: 'Fila {filnamn} er for stor. Maks filstorleik er 4MB.',
        feilFilForLiten: 'Fila {filnavn} er for liten.',
        feilForMangeFiler:
            'Du har prøvd å lasta opp for mange filer på ein gong, prøv å lasta opp færre filer av gongen.',
        feilStandard: 'Det skjedde en feil, prøv igjen.',
        feilTotaltFilstoerrelse: 'Størrelsen på alle filer kan ikkje vera større enn 25MB',
        laster: 'laster...',
    },
    boligAdresseInfo: {
        typeBolig: 'Type bustad ',
        matrikkel: 'Matrikkel ',
        matrikler: 'Matrikler ',
        selveier: 'Sjølveige ',
        borettslag: 'Borettslag ',
        orgNr: 'Org.nummer ',
        andelsnummer: 'Andelsnummer ',
        fellesgjeld: 'Andel i fellesgjeld ',
    },
    geolokasjon: {
        title: 'Ønskjer du å kjøpe bustad i vårt nærområde?',
        subTitle: 'Hei, {fornavn}',
        infoGeolokasjon: {
            hovedinfo:
                'For å oppretthalde vår rolle som lokalbank, ønskjer vi at nye kundar er busett innanfor vårt lokalområde.',
            subinfo:
                'I følge Folkeregisteret er du busett utanfor vårt område. Om dette ikkje stemmer, eller du har planar om å kjøpe bustad i vårt lokalområde, så er du sjølvsagd velkomen til å fortsette søknaden.',
        },
        linkInfo: 'Sjå oversikt over vårt lokalområde',
        modalTitle: 'Vårt lokalområde',
        modalsubtitle: 'Liste med postnummer',
        modalPoststed: '{postnummer}',
    },
    verdivurdering: {
        title: 'Ønskjer du ein verdivurdering av bustaden din?',
        subTitle: 'Tenesta blir levert av Aktiv Eigedomsmekling AS.',
        samtykke:
            'Eg samtykkjer til at {banknamn} deler mobilnummeret mitt, e-posten min og bustaden sin adresse med Aktiv Eigedomsmekling AS, slik at eg kan bli kontakta om verdivurdering av bustad.',
        lesMer: 'Du kan lese meir om Aktiv sine vilkår for personvern på aktiv.no',
        samtykkeError:
            'Samtykke krevst når du har svart ja på ønsket om verdivurdering av bustaden din. For å komme vidare må du endre svaret ditt til Nei, eller gje samtykke til deling av opplysningane med Aktiv',
        endreButton: 'Endre svaret til Nei',
        samtykkeButton: 'Gje samtykke til deling',
        infoModal: {
            title: 'Få verdivurdering',
            tilgang:
                'For å kunne bestille verdivurdering hos Aktiv Eigedomsmekling må dei få tilgang til følgjande informasjon:',
            epost: 'din epost',
            tlf: 'ditt mobilnummer',
            adresse: 'bustaden sin adresse',
            ansvar: 'Aktiv Eigedomsmekling blir ansvarleg for vidare behandling av desse personopplysningane. Du kan lese meir om vilkåra deira for personvern på aktiv.no.',
        },
    },
    ok: 'Ok',
};

export default nnTranslations;
